import React from 'react';
import PT from 'prop-types';
// import { LoginPage } from 'pages';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  // Add your own authentication on the below line.
  const isLoggedIn = sessionStorage.getItem('username') == null;
  return isLoggedIn ? <Navigate to="/login" /> : <Outlet />;
};
PrivateRoute.propTypes = {
  element: PT.any,
  path: PT.any
};
export default PrivateRoute;
